import { confirmAlert } from 'react-confirm-alert';

class CommonUtils {
    static mainSiteTitle = 'Careermon';

    static displayConfirmAlert(
        message = "You don't have right to access this page",
        okOption = {
            label: 'Close',
            className: 'btn-secondary',
            onClick: () => {}
        },
        cancelOption = null,
        title = 'Sign in',
        height = '180px'
    ) {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-leave-alert">
                        <div style={{ minHeight: height }} className="react-confirm-alert-body">
                            <div className="content">
                                <h1>{title}</h1>
                                <p dangerouslySetInnerHTML={{ __html: message }} />
                            </div>
                            <div className="react-confirm-alert-button-group">
                                {cancelOption && (
                                    <button
                                        onClick={() => {
                                            if (cancelOption.onClick) {
                                                cancelOption.onClick();
                                            }
                                            onClose();
                                        }}
                                        className="btn btn-link"
                                    >
                                        {cancelOption.label}
                                    </button>
                                )}
                                <button
                                    onClick={() => {
                                        if (okOption.onClick) {
                                            okOption.onClick();
                                        }
                                        onClose();
                                    }}
                                    className={`btn btn-link btn-secondary ${okOption.className}`}
                                >
                                    {okOption.label}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static displayConfirmSubmit(
        message = "You don't have right to access this page",
        okOption = {
            label: 'Close',
            className: 'btn-secondary',
            onClick: () => {}
        },
        height = '180px'
    ) {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="confirm-submit-alert">
                        <div style={{ minHeight: height }} className="react-confirm-alert-body">
                            <div className="content">
                                <p>{message}</p>
                            </div>
                            <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    onClose();
                                }}
                                className="confirm-btn-close"
                            ></span>
                            <div className="react-confirm-alert-button-group">
                                <button
                                    onClick={() => {
                                        onClose();
                                    }}
                                    className="btn btn-link"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        if (okOption.onClick) {
                                            okOption.onClick();
                                        }
                                        onClose();
                                    }}
                                    className={`btn btn-save-confirm ${okOption.className}`}
                                >
                                    {okOption.label}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static confirmDiscardForm(message, onDiscard, cancelLabel = 'Cancel', okLabel = 'Discard') {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="narrow-modal common-warning-modal">
                        <div className="react-confirm-alert-body">
                            <div className="warning-box">
                                <p>{message}</p>
                            </div>
                            <div className="react-confirm-alert-button-group">
                                <button onClick={onClose} className="btn btn-link btn-secondary">
                                    {cancelLabel}
                                </button>
                                <button
                                    onClick={(event) => {
                                        onDiscard();
                                        onClose();
                                    }}
                                    className="btn btn-link"
                                >
                                    {okLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static useClickOutside(ref, onClickOutside) {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside(event);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }

    static getDefaultAvatar(name) {
        let firstTwoCharsOfName = 'CM';
        if (name?.length > 1) {
            firstTwoCharsOfName = name.slice(0, 2);
        }
        return firstTwoCharsOfName.toUpperCase();
    }
}

export default CommonUtils;
